import React, { useState } from 'react';

export default function CustomizePage() {
  const [fileName, setFileName] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleFile = (file) => {
    if (file && file.name.toLowerCase().endsWith('.stl')) {
      setFileName(file.name);
    } else {
      alert('Please upload a .stl file.');
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    handleFile(e.dataTransfer.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: send file + order details to backend once ready
  };

  return (
    <>
      <div className="page-header">
        <span className="badge">Custom Print</span>
        <h1>Customize Yours</h1>
        <p>Upload your own .stl file, choose your material and color, and we'll take care of the print.</p>
      </div>

      <div className="customize-page">
        <form className="customize-card hud-frame" onSubmit={handleSubmit}>

          <div
            className={`dropzone ${isDragging ? 'dragging' : ''} ${fileName ? 'has-file' : ''}`}
            onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
            onDragLeave={() => setIsDragging(false)}
            onDrop={handleDrop}
            onClick={() => document.getElementById('stl-input').click()}
          >
            <input
              id="stl-input"
              type="file"
              accept=".stl"
              hidden
              onChange={(e) => handleFile(e.target.files[0])}
            />
            {fileName ? (
              <>
                <p className="dropzone-file">{fileName}</p>
                <p className="dropzone-hint">FILE_LOADED — click to replace</p>
              </>
            ) : (
              <>
                <p className="dropzone-main">Drop your .stl file here</p>
                <p className="dropzone-hint">or click to browse</p>
              </>
            )}
          </div>

          <div className="auth-field">
            <label>Material</label>
            <select defaultValue="pla" className="customize-select">
              <option value="pla">PLA</option>
              <option value="petg">PETG</option>
              <option value="abs">ABS</option>
              <option value="resin">Resin</option>
            </select>
          </div>

          <div className="auth-field">
            <label>Filament Color</label>
            <div className="color-options">
              <button type="button" className="color-dot teal active"></button>
              <button type="button" className="color-dot purple"></button>
              <button type="button" className="color-dot gloss-black"></button>
            </div>
          </div>

          <div className="auth-field">
            <label>Notes (optional)</label>
            <textarea
              className="customize-textarea"
              placeholder="Scale, infill, deadline, anything we should know..."
              rows={4}
            />
          </div>

          <button type="submit" className="auth-submit" disabled={!fileName}>
            [ REQUEST_QUOTE ]
          </button>
        </form>
      </div>
    </>
  );
}